import { render, staticRenderFns } from "./dd-mobile-menu.vue?vue&type=template&id=2158444a&"
import script from "./dd-mobile-menu.vue?vue&type=script&lang=ts&"
export * from "./dd-mobile-menu.vue?vue&type=script&lang=ts&"
import style0 from "./dd-mobile-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports